import PropTypes from "prop-types";
import "./Modal.scss";
import Button from "core/buttons/button/Button";
import Icon from "core/icon/Icon";
import ReactDom from "react-dom";
import deleteIcon from "assets/icons/delete-modal-icon.svg";
import { FormattedMessage, useIntl } from "react-intl";

const DEFAULT_CONFIRM_LABEL = { id: "delete", defaultMessage: "Supprimer" };

const DeleteModal = ({
  open,
  onClose,
  onValidate,
  messageId,
  validationMessages = null,
  values = undefined,
  highlight = undefined,
  confirmLabel = DEFAULT_CONFIRM_LABEL,
}) => {
  const intl = useIntl();

  if (!open) return null;

  const clientName = validationMessages?.client_name
    ? intl.formatMessage({
        id: validationMessages.client_name,
        defaultMessage: validationMessages.client_name,
      })
    : null;

  return ReactDom.createPortal(
    <>
      <div className="overlay-style" />
      <div className="validation-modal-style">
        <div className="header">
          <Icon
            color="gray-200"
            icon="close"
            onClick={onClose}
            dataTestId="delete_modale-close_btn"
          />
        </div>
        <div className="body">
          <div>
            <div
              style={{
                backgroundImage: `url(${deleteIcon})`,
              }}
              className="validation-icon"
            />
          </div>
          <div className="title">
            {validationMessages
              ? intl
                  .formatMessage({
                    id: validationMessages.title,
                    defaultMessage: validationMessages.title,
                  })
                  .toUpperCase()
              : intl
                  .formatMessage({
                    id: "sheet_deletion",
                    defaultMessage: "Suppression de la fiche",
                  })
                  .toUpperCase()}
          </div>
          <div className="description">
            {highlight != null && (
              <>
                <strong>{highlight}</strong>
                <br />
              </>
            )}
            <FormattedMessage
              id={
                validationMessages
                  ? validationMessages.message
                  : "modal_delete_common_msg"
              }
              defaultMessage=" Es-tu sûr.e de vouloir effectuer cette action ?"
              values={values}
            />
            {clientName === null ? (
              messageId && (
                <>
                  <br />
                  <FormattedMessage id={messageId} defaultMessage={messageId} />
                </>
              )
            ) : (
              <>
                <br />
                <strong>{clientName}</strong>
              </>
            )}
          </div>
          <div className="form-buttons">
            <Button
              className="btn-standard btn-outline"
              onClick={onClose}
              type="button"
              id="button-form-reset"
              dataTestId="delete_modale-cancel_btn"
            >
              <FormattedMessage id="cancel" defaultMessage="Annuler" />
            </Button>
            <Button
              color="btn-medium gray-700"
              type="submit"
              onClick={onValidate}
              id="button-form-validation"
              dataTestId="delete_modale-delete_btn"
            >
              <FormattedMessage {...confirmLabel} />
            </Button>
          </div>
          <br /> <br />
        </div>
      </div>
    </>,
    document.getElementById("portal")
  );
};

export default DeleteModal;

DeleteModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onValidate: PropTypes.func,
  messageId: PropTypes.string,
  validationMessages: PropTypes.object,
  values: PropTypes.object,
  highlight: PropTypes.string,
  confirmLabel: PropTypes.object,
};
